import { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setIsLoading(true)
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/set-password`,
    })
    setIsLoading(false)
    if (resetError) { setError('Kon geen reset link versturen. Probeer het opnieuw.'); return }
    setSent(true)
  }

  return (
    <div className="min-h-screen bg-muted flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-md p-8 max-w-md w-full">
        <div className="flex justify-center mb-6">
          <div className="w-12 h-12 bg-indigo-500 rounded-xl flex items-center justify-center">
            <span className="text-white font-bold text-xl">C</span>
          </div>
        </div>
        <h1 className="text-2xl font-bold text-center mb-2">Wachtwoord vergeten</h1>
        {sent ? (
          <div className="text-center mt-6">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
              </svg>
            </div>
            <p className="font-medium">Link verstuurd!</p>
            <p className="text-slate-500 text-sm mt-2">Check je inbox voor de reset link.</p>
            <Link to="/login" className="text-indigo-500 text-sm mt-4 inline-block hover:underline">← Terug naar login</Link>
          </div>
        ) : (
          <>
            <p className="text-slate-500 text-center mb-8">Vul je e-mailadres in. We sturen een link om je wachtwoord te resetten.</p>
            {error && <div className="bg-red-50 border border-red-200 text-red-600 rounded-lg p-3 mb-6 text-sm">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium mb-1">E-mailadres</label>
                <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500" placeholder="je.naam@cincocleaning.com" disabled={isLoading} />
              </div>
              <button type="submit" disabled={isLoading || !email} className="w-full bg-indigo-500 hover:bg-indigo-600 disabled:bg-gray-300 text-white font-semibold py-3 rounded-full transition-colors">
                {isLoading ? 'Versturen...' : 'Stuur reset link'}
              </button>
            </form>
            <p className="text-center mt-4">
              <Link to="/login" className="text-indigo-500 text-sm hover:underline">← Terug naar login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  )
}
